import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const AddPluginCollaboratorDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddPluginCollaborator"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addPluginCollaborator"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idMember"}}},{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AddPluginCollaborator","document":AddPluginCollaboratorDocument}} as const;
export type AddPluginCollaboratorMutationVariables = Types.Exact<{
  idMember: Types.Scalars['ID']['input'];
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type AddPluginCollaboratorMutation = (
  { __typename: 'Mutation' }
  & { addPluginCollaborator?: Types.Maybe<(
    { __typename: 'Plugin_Collaborators_UpdateResponse' }
    & Pick<Types.Plugin_Collaborators_UpdateResponse, 'success'>
  )> }
);

export type AddPluginCollaboratorMutationFn = Apollo.MutationFunction<
  AddPluginCollaboratorMutation,
  AddPluginCollaboratorMutationVariables
>;

/**
 * __useAddPluginCollaboratorMutation__
 *
 * To run a mutation, you first call `useAddPluginCollaboratorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPluginCollaboratorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPluginCollaboratorMutation, { data, loading, error }] = useAddPluginCollaboratorMutation({
 *   variables: {
 *      idMember: // value for 'idMember'
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function useAddPluginCollaboratorMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AddPluginCollaboratorMutation,
    AddPluginCollaboratorMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AddPluginCollaboratorMutation,
    AddPluginCollaboratorMutationVariables
  >(AddPluginCollaboratorDocument, options);
}
export type AddPluginCollaboratorMutationHookResult = ReturnType<
  typeof useAddPluginCollaboratorMutation
>;
export type AddPluginCollaboratorMutationResult =
  Apollo.MutationResult<AddPluginCollaboratorMutation>;
export type AddPluginCollaboratorMutationOptions = Apollo.BaseMutationOptions<
  AddPluginCollaboratorMutation,
  AddPluginCollaboratorMutationVariables
>;
